export default "__VITE_ASSET__116555d8__"